import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IPublishDraftJobPostPayload } from '../types';

export const publishDraftJobPost = async (payload: IPublishDraftJobPostPayload): Promise<void> => {
  const headers = await getAuthHeaders();

  await tempMeeApi.post(
    `/posting-service/postings/${payload.jobPostingId}/publish`,
    {
      planId: payload.planId,
      ...(payload.promoCode !== undefined && { promoCode: payload.promoCode }),
      ...(payload.expectedFinalPrice !== undefined && { expectedFinalPrice: payload.expectedFinalPrice }),
    },
    { headers },
  );
};
